<template>
  <v-container class="pa-5a text-center">
    <v-avatar color="red">
      <span class="white--text headline">{{ timer }}</span>
    </v-avatar>
  </v-container>
</template>

<script>
export default {
  name: "Timer",
  props: {
    endTime: Number,
  },
  created() {
    this.startTimer();
  },
  watch: {
    timer: {
      handler(value) {
        if (value > 0) {
          this.showTimer = true;
          setTimeout(() => {
            this.timer--;
          }, 1000);
        } else if (value == 0) {
          console.log("emitting end-turn!");
          this.$root.$emit("end-turn");
          this.showTimer = false;
        }
      },
    },
  },
  methods: {
    startTimer() {
      var value = Math.floor((this.endTime - Date.now()) / 1000);
      this.timer = value;
    },
  },
  data() {
    return {
      players: [],
      timer: 0,
      showTimer: false,
    };
  },
};
</script>
